// @ts-strict-ignore
import { ActionListItem } from '../model/action-list-item';
import { BoardSettings } from '../model/board-settings';
import { ClientAction } from '../model/client-model/client-action';

interface FilterOnSwimlaneBoardModel {
  boardSettings: Pick<BoardSettings, 'swimlanes'>;
}

// TODO: This function should also be removed after we've migrated actions
/**
 * @deprecated will be removed after action migration
 */
export function filterOnSwimlane(action: ClientAction | ActionListItem, board: FilterOnSwimlaneBoardModel): boolean {
  return board.boardSettings.swimlanes?.some((s) => s.id === action.actionProperties.swimlane);
}
